import { useContext } from 'react';

import { useCurrentUserQuery } from '@/features/users';
import { UserTypeContext } from '@/shared/lib/UserTypeContext/UserTypeContext';
import { checkPermission } from '@/shared/lib/permissions';

const DEPLOYMENT_ADMIN_PERMISSION = 'edit:deployment-admin';

export interface DeploymentDashboardAccess {
  hasAccess: boolean;
  isResolving: boolean;
}

export const useDeploymentDashboardAccess = (): DeploymentDashboardAccess => {
  const isServiceUser = useContext(UserTypeContext) === 'service';
  const { data: currentUser, isLoading } = useCurrentUserQuery();
  return {
    hasAccess: isServiceUser && checkPermission(currentUser, DEPLOYMENT_ADMIN_PERMISSION),
    isResolving: isServiceUser && isLoading,
  };
};
